(function ($, Global) {
    function MenuInsidersComponent() {
        // Déclaration class objet
    }

	MenuInsidersComponent.prototype.initEvents = function () {
		this.publishers();
	}

	MenuInsidersComponent.prototype.publishers = function () {
		var self = this;

        $(document).on('show.bs.dropdown', '.menu-insiders .navbar-right > li', function () {
            self.toggleMenuInsiders(this, true);
        });
        $(document).on('hide.bs.dropdown', '.menu-insiders .navbar-right > li', function () {
            self.toggleMenuInsiders(this, false);
        });
	}

	MenuInsidersComponent.prototype.toggleMenuInsiders = function (el, showing) {
		var $el = $(el);
		var $icon = $el.find('.icon:first');
		var methodClass = showing ? 'addClass' : 'removeClass';

		$('.menutop')[methodClass]('out');
        $('.menu-insiders-backdrop')[methodClass]('in');
		$('.menu-insiders')[methodClass]('in');

		$icon.toggleIconClass('icon-21', 'icon-222');
	}

	Global.MenuInsidersComponent = MenuInsidersComponent;
}(jQuery, window));